import { COMMAND, COMMAND_SUB_TYPES, ENABLE_STATE, DISABLE_STATE, SITE_COMMANDS, LOCATION_COMMANDS, ZONE_COMMANDS } from "../../../constants/widget-constants";
import { TranslationKeys } from "../../../contexts/TranslationKeys";
import { Translator } from "../../../contexts/translator";
import { ExecuteCommand } from "../../../models/ExecuteCommand";
import { Widget } from "../../../models/Widget";

export const buildCmdFailureMsg = (commandType: string, translate: Translator, countFailures: number, listFailures: string[]) => {
    switch (commandType) {
        case COMMAND_SUB_TYPES.EMERGENCY_MODE:
            return translate.byKeyFormatted(TranslationKeys.failedToExecuteEmergencyMode, [countFailures, listFailures.join(",\n")]);
        case COMMAND_SUB_TYPES.LOCKDOWN_MODE:
            return translate.byKeyFormatted(TranslationKeys.failedToExecuteLockdownMode, [countFailures, listFailures.join(",\n")]);
        case COMMAND_SUB_TYPES.OPEN_DOOR:
            return translate.byKeyFormatted(TranslationKeys.failedToExecuteOpenDoor, [countFailures, listFailures.join(",\n")]);
        default:
            return translate.byKeyFormatted(TranslationKeys.failedToExecuteResetApb, [countFailures, listFailures.join(",\n")]);
    }
}

export const buildEmergencyCommand = (status: boolean, widget: Widget): ExecuteCommand => {
    const partialCommand: ExecuteCommand = {
        cmd: COMMAND,
        cmdSubType: COMMAND_SUB_TYPES.EMERGENCY_MODE,
        state: status ? ENABLE_STATE : DISABLE_STATE,
    }

    return getFullCommand(partialCommand, widget);
}

export const buildOpenDoorCommand = (widget: Widget): ExecuteCommand => {
    const partialCommand: ExecuteCommand = {
        cmd: COMMAND,
        cmdSubType: COMMAND_SUB_TYPES.OPEN_DOOR,
    }

    return getFullCommand(partialCommand, widget);
}

export const buildLockdownModeCommand = (status: boolean, widget: Widget): ExecuteCommand => {
    const partialCommand: ExecuteCommand = {
        cmd: COMMAND,
        cmdSubType: COMMAND_SUB_TYPES.LOCKDOWN_MODE,
        state: status ? ENABLE_STATE : DISABLE_STATE,
    }

    return getFullCommand(partialCommand, widget);
}

export const buildResetAPBCommand = (widget: Widget): ExecuteCommand => {
    const partialCommand: ExecuteCommand = {
        cmd: COMMAND,
        cmdSubType: COMMAND_SUB_TYPES.APB_RESET,
    }

    return getFullCommand(partialCommand, widget);
}

export const isResetAPBSupported = (widget: Widget) => {
    const supportedTypes: String[] = [SITE_COMMANDS];
    return supportedTypes.includes(getEsysnameLookup(widget));
}

const getEsysnameLookup = (widget: Widget) => {
    return widget.relationships.length > 0 && widget.relationships[0]["eSysnameLookup"];
}

const getFullCommand = (command: ExecuteCommand, widget: Widget) => {
    switch (getEsysnameLookup(widget)) {
        case SITE_COMMANDS:
            return { ...command, siteId: widget.relationships.length > 0 && widget.relationships[0]["siteId"] };
        case LOCATION_COMMANDS:
            return { ...command, doorId: widget.relationships.length > 0 && widget.relationships[0]["doorId"] };
        case ZONE_COMMANDS:
            return { ...command, zoneId: widget.relationships.length > 0 && widget.relationships[0]["zoneId"] };
        default:
            return command;
    }
}

export const getCommandTitle = (commandType: string, translate: Translator) => {
    switch (commandType) {
        case SITE_COMMANDS:
            return translate.byKey(TranslationKeys.site);
        case LOCATION_COMMANDS:
            return translate.byKey(TranslationKeys.door);
        case ZONE_COMMANDS:
            return translate.byKey(TranslationKeys.zone);
        default:
            return "";
    }
}

export const getCommandkey = (commandType: string) => {
    switch (commandType) {
        case SITE_COMMANDS:
            return "siteId";
        case LOCATION_COMMANDS:
            return "locationId";
        case ZONE_COMMANDS:
            return "zoneId";
        default:
            return "";
    }
}